import { type z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';
import { GenderSchema } from '../../users/gender';

import { VerificationCaseKindSchema } from '../verification-case-kind/verification-case-kind';
import { VerificationCaseStatusSchema } from '../verification-case-status/verification-case-status';
import { VerificationQueueSchema } from '../verification-queue/verification-queue';

/**
 * The whitelisted filters for the staff review queue (N7).
 *
 * `gender` **narrows**; it can never widen. When
 * `verification.genderMatchedReview` is on, the endpoint restricts the queue to
 * the reviewer's own gender below the filter layer, from the token — so a client
 * asking for the other gender gets an empty page rather than a bypass. There is
 * deliberately no parameter that could switch that restriction off.
 *
 * There is also no `decidedByUserId`: a review queue is a work list, not a way
 * to pull up everything a named colleague decided.
 */
export const VerificationCasesListQuerySchema = makeListQuery({
  status: VerificationCaseStatusSchema.optional(),
  gender: GenderSchema.optional(),
  /** First looks and re-reviews (D6) are different work; a reviewer may take one at a time. */
  kind: VerificationCaseKindSchema.optional(),
  /** One of the work lists (F7); absent means the plain list the other filters cut. */
  queue: VerificationQueueSchema.optional(),
});

export type VerificationCasesListQuery = z.infer<typeof VerificationCasesListQuerySchema>;
